var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"return",attrs:{"title":"返回"},on:{"click":_vm.handleReturn}},[_c('i',{staticClass:"iconfont iconfontfanhui"})]),_c('div',{staticClass:"content"},[(_vm.showSkeleton)?_c('el-skeleton',{attrs:{"rows":32,"animated":""}}):_c('div',{ref:"container",staticClass:"markdown-body"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }